import { reportAxios } from "ultis/axios";

/**api năng suất gọi vào */
const getReportInboundPerformance = (body) => {
  return reportAxios.post(
    "/api/v1/reports/inbound-call/report-agent-performance",
    body
  );
};

/**api báo cáo máy lẻ */
const getReportExtension = (body) => {
  return reportAxios.post("/api/v1/reports/extension", body);
};

/**api lấy lịch sử xuất báo cáo cuộc gọi */
const getCallLogReports = (params) => {
  return reportAxios.get("/api/v1/report-schedule", {
    params,
  });
};

const getDetailInboundCall = (params) => {
  return reportAxios.get("/api/v1/reports-v2/detail-inbound-call", {
    params,
  });
};

const getCountDetailInboundCall = (params) => {
  return reportAxios.get("/api/v1/reports-v2/detail-inbound-call/count", {
    params,
  });
};

const getDetailOutboundCall = (params) => {
  return reportAxios.get("/api/v1/reports-v2/detail-outbound-call", {
    params,
  });
};

const getCountDetailOutboundCall = (params) => {
  return reportAxios.get("/api/v1/reports-v2/detail-outbound-call/count", {
    params,
  });
};

const getDetailFailedOutboundCall = (params) => {
  return reportAxios.get("/api/v1/reports-v2/detail-failed-outbound-call", {
    params,
  });
};

const getDetailFailedInboundCall = (params) => {
  return reportAxios.get("/api/v1/reports-v2/detail-failed-inbound-call", {
    params,
  });
};

const getReportOutboundCallByExt = (params) => {
  return reportAxios.get("/api/v1/reports-v2/synthesis-outbound-call-by-ext", {
    params,
  });
};

const getCountOutboundCallByExt = (params) => {
  return reportAxios.get(
    "/api/v1/reports-v2/synthesis-outbound-call-by-ext/count",
    {
      params,
    }
  );
};
const getReportOutboundCallByUnit = (params) => {
  return reportAxios.get("/api/v1/reports-v2/synthesis-outbound-call-by-unit", {
    params,
  });
};

const getCountOutboundCallByUnit = (params) => {
  return reportAxios.get(
    "/api/v1/reports-v2/synthesis-outbound-call-by-unit/count",
    {
      params,
    }
  );
};
const getReportInboundCallByExt = (params) => {
  return reportAxios.get("/api/v1/reports-v2/synthesis-inbound-call-by-ext", {
    params,
  });
};

const getReportInboundCallByUnit = (params) => {
  return reportAxios.get("/api/v1/reports-v2/synthesis-inbound-call-by-unit", {
    params,
  });
};

const getReportSynthesisFailedCall = (params) => {
  return reportAxios.get("/api/v1/reports-v2/synthesis-failed-call", {
    params,
  });
};

const getReportExtNotCall = (params) => {
  return reportAxios.get("/api/v1/reports-v2/report-ext-not-call", {
    params,
  });
};

export const ReportApi = {
  getReportInboundPerformance,
  getReportExtension,
  getCallLogReports,
  getDetailInboundCall,
  getDetailOutboundCall,
  getCountDetailInboundCall,
  getCountDetailOutboundCall,
  getReportOutboundCallByExt,
  getCountOutboundCallByExt,
  getReportOutboundCallByUnit,
  getCountOutboundCallByUnit,
  getReportInboundCallByExt,
  getReportInboundCallByUnit,
  getDetailFailedOutboundCall,
  getDetailFailedInboundCall,
  getReportSynthesisFailedCall,
  getReportExtNotCall,
};
